import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { arrayOf, shape, string, bool } from 'prop-types'

import styles from '../../Footer.module.scss'

import List from '@/component/Primitive/List'
import SmartLink from '@/component/Primitive/SmartLink'
import Type from '@/component/Primitive/Type'
import Icon from '@/component/Primitive/Icon'
import ShrinkWrap from '@/component/Primitive/ShrinkWrap'
import Hide from '@/component/Primitive/Hide'
import TextAlign from '@/component/Primitive/TextAlign'

const FooterNavigation = ({ title, content }) => {
  const [expanded, setExpanded] = useState(
    typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 960px)').matches
  )

  useEffect(() => {
    const handleResize = () => {
      const mq = window && window.matchMedia('(min-width: 960px)')
      setExpanded(mq.matches)
    }

    typeof window !== 'undefined' &&
      window.addEventListener('resize', handleResize)

    return () => {
      typeof window !== 'undefined' &&
        window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleToggle = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <Hide at="desktop">
        <button className={styles.FooterNavColumnHeader} onClick={handleToggle}>
          <ShrinkWrap fullWidth vAlign="middle">
            <ShrinkWrap.Item>
              <TextAlign left>
                <Type themed size="heading6" weight="bold">
                  {title}
                </Type>
              </TextAlign>
            </ShrinkWrap.Item>
            <ShrinkWrap.Item shrink>
              <Icon
                className={classNames(styles.Icon, expanded && styles.rotated)}
                type="arrow-down"
                width={12}
              />
            </ShrinkWrap.Item>
          </ShrinkWrap>
        </button>
      </Hide>
      <Hide below="desktop">
        <Type
          className={styles.FooterNavColumnHeader}
          size={['heading6', 'heading8']}
          weight="bold"
          themed
        >
          {title}
        </Type>
      </Hide>
      {expanded && (
        <List unstyled className={styles.FooterNavList}>
          {content.map(({ url, type, title }, index) => (
            <li
              className={styles.FooterLinksListItem}
              key={`FooterLinksList--${index}`}
            >
              <SmartLink
                href={type === 'externalLink' ? url : undefined}
                to="/section"
                as={url}
                target={type === 'externalLink' ? '_blank' : undefined}
                className={styles.FooterNavLink}
              >
                <Type as="span" size={['heading6', 'body3']} weight="medium">
                  {title}
                </Type>
              </SmartLink>
            </li>
          ))}
        </List>
      )}
    </>
  )
}

FooterNavigation.propTypes = {
  title: string,
  content: arrayOf(
    shape({
      text: string,
      href: string,
      isExternal: bool
    })
  )
}

export default FooterNavigation
